import { useId } from 'react';

import { CheckboxField } from '@nesso/ui/primitives/checkbox-field';
import { TreeNode } from '@nesso/ui/primitives/tree-node';

import { CheckboxListWithOther } from '@/shared/ui/checkbox-list/checkbox-list-with-other';

type CheckboxOption = { value: string; label: string };

type Props = {
    label: string;
    options: CheckboxOption[];
    selection: string[];
    other?: string;
    active: boolean;
    onToggle: (checked: boolean) => void;
    onSelectionChange: (next: string[]) => void;
    onOtherChange: (next: string | undefined) => void;
};

export function NessoSymptomGroupNode({
    label,
    options,
    selection,
    other,
    active,
    onToggle,
    onSelectionChange,
    onOtherChange,
}: Props) {
    const id = useId();
    return (
        <TreeNode
            open={active}
            triggerAsToggle={false}
            trigger={
                <CheckboxField
                    id={id}
                    label={label}
                    checked={active}
                    onCheckedChange={(value) => onToggle(value === true)}
                />
            }
        >
            <div className="w-full py-2">
                <CheckboxListWithOther
                    columns={1}
                    options={options}
                    values={selection}
                    onValuesChange={onSelectionChange}
                    otherValue={other}
                    onOtherValueChange={onOtherChange}
                />
            </div>
        </TreeNode>
    );
}
